import { Injectable } from '@angular/core';

import { OddsAcceptanceMode } from '@bpos';
import { OddsComparerFactory } from '@frontend/sports/odds/feature';

import { BetslipPick } from '../../../../../../core/picks/betslip-pick';
import BetslipPickUtilsService from '../../../../../picks/services/betslip-pick-utils.service';

@Injectable({ providedIn: 'root' })
export class OddsChangedHelperService {
    constructor(
        private oddsCompareFactory: OddsComparerFactory,
        private betslipPickUtils: BetslipPickUtilsService,
    ) {}

    areOddsAccepted(pick: BetslipPick | undefined, oddsAcceptanceMode: OddsAcceptanceMode): boolean {
        if (oddsAcceptanceMode === OddsAcceptanceMode.Any || !pick?.currentPrice || !pick.acceptedPrice.price) {
            return true;
        }

        const oddsChanged = this.betslipPickUtils.compareAgainstLastPrice(pick);
        if (oddsChanged) {
            const currentOdds = pick.currentPrice.nativeOdds;
            const acceptedOdds = pick.acceptedPrice.price.nativeOdds;

            const currentOddsComparer = this.oddsCompareFactory.createComparer(currentOdds);
            const oddsAccepted = oddsAcceptanceMode === OddsAcceptanceMode.Higher && currentOddsComparer.greaterOrEqualThan(acceptedOdds);
            if (!oddsAccepted) {
                return false;
            }
        }

        return true;
    }

    areAllPickOddsAccepted(picks: BetslipPick[], oddsAcceptanceMode: OddsAcceptanceMode): boolean {
        for (const pick of picks) {
            if (!this.areOddsAccepted(pick, oddsAcceptanceMode)) {
                return false;
            }
        }

        return true;
    }
}
